<template>
  <div class="account">
    <AccountDetailPage />
  </div>
</template>

<script>
import AccountDetailPage from '../components/elements/pages/AccountDetailPage.vue'
export default {
  name: 'AccountDetail',
  metaInfo: {
    title: 'Account Detail'
  },
  components: {
    AccountDetailPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
